import { importScreen } from '@infrastructure/splitting';

const ReportList = importScreen(() => import('./containers'));

export { ReportList };
